export { SkipSSR } from './SkipSSR';
export { useSSR } from './useSSR';

export const isSSR = typeof window === 'undefined';
